// extracted by mini-css-extract-plugin
export var active = "avatar-module--active--qiag+";
export var activist = "avatar-module--activist--FF6kw";
export var athletic = "avatar-module--athletic--fAB6K";
export var avatarImage = "avatar-module--avatarImage--myrzj";
export var bookworm = "avatar-module--bookworm--6q05O";
export var chill = "avatar-module--chill--pQ5pv";
export var defaultAvatar = "avatar-module--defaultAvatar--HjULB";
export var gamer = "avatar-module--gamer--o44-O";
export var glam = "avatar-module--glam--gOl00";
export var hipster = "avatar-module--hipster--rO4p9";
export var prep = "avatar-module--prep--ROcnL";
export var root = "avatar-module--root--N+0Ar";
export var skater = "avatar-module--skater--FamRp";
export var street = "avatar-module--street--DJNvh";